<template>
  <div style="min-height: calc(100vh - 350px); padding-top: 70px;">
    <v-alert
      class="alert-cart"
      height="50"
      transition="fade-transition"
      v-model="alertaWishlist"
      color="#A37E60"
    >
      <span>Se ha eliminado un producto de tu Colección Privada</span>
      <div class="centrar-right">
        <!-- <router-link to="/cart" class="white--text">
                <span>MI CESTA</span>
                <img src="../assets/img/iconos/cesta.svg" alt />
        </router-link>-->
      </div>
    </v-alert>

    <v-container>
      <v-row align="center">
        <v-col cols="4">
          <v-breadcrumbs :items="items" divider="|" class="px-0"></v-breadcrumbs>
        </v-col>
        <v-col cols="4" class="text-center">
          <h1 class="titulo" style="letter-spacing:1px;">WISHLIST</h1>
        </v-col>
      </v-row>
    </v-container>
    <template v-if="wishlist.length > 0">
      <v-container class="pb-0" style="min-height: calc(100vh - 350px - 105px);">
        <v-row class="d-none d-sm-flex">
          <v-col cols="3">
            <span class="modernist-bold">PRODUCTO</span>
          </v-col>
          <v-col cols="3">
            <span class="modernist-bold">DESCRIPCIÓN</span>
          </v-col>
          <v-col cols="2">
            <span class="modernist-bold">PRECIO UNITARIO</span>
          </v-col>
          <v-col cols="2"></v-col>
          <v-col cols="2"></v-col>
        </v-row>

        <v-row
          v-for="(item,i) in wishlist"
          :key="i"
          align="center"
          style="border-top: 1px solid #D8D8D8;"
          class="mt-3 pt-3 d-none d-sm-flex"
        >
          <v-col cols="3">
            <v-img width="231" :src="'https://strapi.actstudio.xyz'+item.ImagenPrincipal.url"></v-img>
          </v-col>
          <v-col cols="3">
            <span
              class="d-block modernist-bold"
              style="font-size: 12px; color: #03241D; text-transform: uppercase;"
            >{{item.NombreComun}}</span>
            <span
              class="d-block modernist-bold"
              style="font-size: 10px; color:#979797; text-transform: uppercase;"
            >{{item.NombreCientifico}}</span>
          </v-col>
          <v-col cols="2">
            <span class="d-block modernist-bold">Desde:</span>
            <template v-if="item.ActivoChico">
              <span class="modernist-bold">${{item.PrecioChico}}.00 MXN</span>
            </template>
            <template v-else-if="item.ActivoMediano">
              <span class="modernist-bold">${{item.PrecioMediano}}.00 MXN</span>
            </template>
            <template v-else-if="item.ActivoGrande">
              <span class="modernist-bold">${{item.PrecioGrande}}.00 MXN</span>
            </template>
          </v-col>
          <v-col cols="2">
            <v-btn @click="eliminarItemWishlist(item.id)" text :ripple="false" color="transparent">
              <v-icon class="mr-4" color="#E2D4CA">mdi-close</v-icon>
              <span class="modernist-bold verde-oscuro" style="font-size: 10px;">ELIMINAR</span>
            </v-btn>
          </v-col>
          <v-col cols="2">
            <router-link :to="'/tienda/'+item.url">
              <v-btn elevation="0" dark color="#064434" tile>
                <span class="modernist-bold" style="font-size: 12px;">Ver producto</span>
              </v-btn>
            </router-link>
          </v-col>
        </v-row>

        <div class="d-sm-none">
          <div v-for="(item,i) in wishlist" :key="i">
            <v-row>
              <v-col cols="6" offset="3">
                <router-link :to="'/tienda/'+item.url">
                  <v-img
                    width="100%"
                    :src="'https://strapi.actstudio.xyz'+item.ImagenPrincipal.url"
                  ></v-img>
                </router-link>
              </v-col>
              <v-col cols="3" class="text-center">
                <v-btn
                  @click="eliminarItemWishlist(item.id)"
                  text
                  :ripple="false"
                  color="transparent"
                >
                  <v-icon color="#E2D4CA">mdi-close</v-icon>
                  <span class="modernist-bold verde-oscuro" style="font-size: 10px;">ELIMINAR</span>
                </v-btn>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" class="text-center">
                <router-link :to="'/tienda/'+item.url">
                  <span
                    class="d-block modernist-bold"
                    style="font-size: 12px; color: #03241D; text-transform: uppercase;"
                  >{{item.NombreComun}}</span>
                </router-link>
                <router-link :to="'/tienda/'+item.url">
                  <span
                    class="d-block modernist-bold"
                    style="font-size: 10px; color:#979797; text-transform: uppercase;"
                  >{{item.NombreCientifico}}</span>
                </router-link>

                <span class="d-block modernist-bold mt-6">Desde:</span>
                <template v-if="item.ActivoChico">
                  <span class="modernist-bold">${{item.PrecioChico}}.00 MXN</span>
                </template>
                <template v-else-if="item.ActivoMediano">
                  <span class="modernist-bold">${{item.PrecioMediano}}.00 MXN</span>
                </template>
                <template v-else-if="item.ActivoGrande">
                  <span class="modernist-bold">${{item.PrecioGrande}}.00 MXN</span>
                </template>
              </v-col>
            </v-row>
            <v-row class="py-0 mb-0">
              <v-col cols="12" class="px-0 py-0">
                <router-link :to="'/tienda/'+item.url">
                  <v-btn block elevation="0" dark color="#064434" tile>
                    <span class="modernist-bold" style="font-size: 12px;">Ver producto</span>
                  </v-btn>
                </router-link>
              </v-col>
            </v-row>
          </div>
        </div>
      </v-container>
    </template>
    <template v-else>
      <v-container>
        <v-row style="height: calc(100vh - 350px - 105px)" align="center">
          <v-col cols="12" class="text-center">
            <span
              class="modernist-bold"
              style="font-size: 26px; letter-spacing: 2px; color: #03241D;"
            >Aún no hay productos</span>
          </v-col>
        </v-row>
      </v-container>
    </template>

    <v-container fluid class="py-0">
      <v-row>
        <v-col class="px-0 py-0">
          <router-link to="/tienda">
            <v-btn block elevation="0" color="#CA8B37" tile height="40" :ripple="false" dark>
              <span
                class="d-block text-center blanco modernist-bold"
                style="font-size: 12px;"
              >IR A LA TIENDA</span>
            </v-btn>
          </router-link>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import Vue from "vue";
import VueSession from "vue-session";
Vue.use(VueSession, { persist: true });
import axios from "axios";

export default {
  data: () => ({
    wishlist: [],
    items: [
      {
        text: "Inicio",
        disabled: false,
        to: "/"
      },
      {
        text: "Wishlist",
        disabled: true
      }
    ],
    alertaWishlist: false
  }),
  created: function() {
    axios
      .get(
        "https://strapi.actstudio.xyz/users/" +
          this.$session.get("user").user.id,
        {
          headers: {
            Authorization: `Bearer ${this.$session.get("user").jwt}`
          }
        }
      )
      .then(response => {
        this.wishlist = response.data.productos;
      })
      .catch(error => {});
  },
  methods: {
    eliminarItemWishlist: function(id) {
      var m = [];

      for (let n = 0; n < this.wishlist.length; n++) {
        if (this.wishlist[n].id != id) {
          console.log(this.wishlist[n]);
          m.push({ id: this.wishlist[n].id });
        }
      }

      axios
        .put(
          "https://strapi.actstudio.xyz/users/" +
            this.$session.get("user").user.id,
          {
            headers: {
              Authorization: `Bearer ${this.$session.get("user").jwt}`
            },
            id: this.$session.get("user").jwt,
            productos: m
          }
        )
        .then(response => {
          console.log(response.data);

          axios
            .get(
              "https://strapi.actstudio.xyz/users/" +
                this.$session.get("user").user.id,
              {
                headers: {
                  Authorization: `Bearer ${this.$session.get("user").jwt}`
                }
              }
            )
            .then(response => {
              this.wishlist = response.data.productos;
            })
            .catch(error => {});
        });

      var aux2 = this;
      this.alertaWishlist = true;
      setTimeout(function() {
        aux2.alertaWishlist = false;
      }, 3000);
    }
  },
  mounted: function() {
    //emitir evento para ocultarc menú
    this.$emit("updateMenu", 1);
    gtag('config', 'UA-163902944-1', {
        'page_title' : 'Wishlist',
        'page_path': '/wishlist'
    });
  }
};
</script>